import { ReactNode } from 'react';
import { breakpoints } from 'styles';

interface Props {
  children: ReactNode;
  isHomeView: boolean;
}

const CoursesWrapper = ({ children, isHomeView }: Props) => (
  <div className={`courses courses-${isHomeView ? 'home' : 'default'}`}>
    {children}

    <style jsx>{`
      .courses {
        display: flex;
        gap: 30px;
      }
      .courses-default {
        flex-wrap: wrap;
      }
      .courses-home {
        flex-wrap: nowrap;
        overflow: auto;
        padding: 3px 0;
      }
      .courses-default :global(> div) {
        width: 100%;
      }
      .courses-home :global(> div) {
        flex-shrink: 0;
        width: 280px;
      }
      @media (min-width: ${breakpoints.small}px) {
        .courses-home {
          flex-wrap: wrap;
          overflow: visible;
          padding: 0;
        }
        .courses-default :global(> div),
        .courses-home :global(> div) {
          flex-shrink: 1;
          width: calc(50% - 15px);
        }
      }
      @media (min-width: ${breakpoints.medium}px) {
        .courses-default :global(> div) {
          flex-shrink: 1;
          width: 100%;
        }
      }
      @media (min-width: 900px) {
        .courses-default :global(> div) {
          width: calc(50% - 15px);
        }
        .courses-home :global(> div) {
          width: calc(33.333% - 20px);
        }
      }
      @media (min-width: 1100px) {
        .courses-default :global(> div) {
          width: calc(33.333% - 20px);
        }
        .courses-home :global(> div) {
          width: calc(25% - 22.5px);
        }
      }
    `}</style>
  </div>
);

export default CoursesWrapper;
